/**
 * Module: search-toggle.js
 * Handles the search toggles in the Search Window/Results
 */

export default (enableDebug = false) => {
	const toggleGroups = document.querySelectorAll('.search-toggle__search-type__parent');
	if (!toggleGroups.length) {
		console.warn('No toggle groups found');
		return;
	}

	toggleGroups.forEach(parent => {
		const container = parent.closest('.search-toggle__search-type');
		if (!container) return;

		const fauxToggle = container.querySelector('.search-type--toggle');
		const radios = parent.querySelectorAll('input[type="radio"]');

		const handleSelection = (value) => {
			if (fauxToggle) {
				fauxToggle.className = '';
				fauxToggle.classList.add(value);
			}
			console.log(`[Toggle] Updated container (${value})`, container);
		};

		parent.addEventListener('change', (e) => {
			if (e.target.type === 'radio') {
				radios.forEach(r => r.checked = false);
				e.target.checked = true;
				handleSelection(e.target.value);
			}
		});

		if (fauxToggle) {
			fauxToggle.addEventListener('click', () => {
				const uncheckedRadio = [...radios].find(r => !r.checked);
				if (uncheckedRadio) {
					radios.forEach(r => r.checked = false);
					uncheckedRadio.checked = true;
					handleSelection(uncheckedRadio.value);
				}
			});
		}
	});
};
